var ngModule;
try {
  ngModule = angular.module('templates');
} catch (e) {
  ngModule = angular.module('templates', []);
}

ngModule.run(['$templateCache', function ($templateCache) {
  $templateCache.put('/modals/mountain-route-images/mountain-route-images.html',
    '<div class="modal-body">\n' +
    '	<h2 class="margin_b_20">Добавить новые фотографии</h2>\n' +
    '\n' +
    '  <div class="clearfix" ng-repeat="image in routeImages.slidesFiles.queue">\n' +
    '    <div class="form__fieldset center" ng-if="image.isUploading">\n' +
    '      <button class="btn-show btn-show_active">Загружаю</button>\n' +
    '    </div>\n' +
    '    <div class="form__fieldset" ng-if="image.isUploaded">\n' +
    '      <div class="form-group_inline width-350">\n' +
    '        <img class="img-responsive" ng-src="{{ image.serverData.thumb_path }}">\n' +
    '      </div>\n' +
    '      <div class="form-group_inline width-350">\n' +
    '        <textarea class="form__item" ng-model="image.serverData.description"></textarea>\n' +
    '      </div>\n' +
    '      <button type="button" class="btn-standart right" ng-click="image.remove()" ng-if="routeImages.isAdmin">Удалить</button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="form__fieldset">\n' +
    '    <button type="button" class="btn-standart relative">Добавить фотографию\n' +
    '        <input class="docs__input_file" type="file" nv-file-select uploader="routeImages.slidesFiles" />\n' +
    '    </button>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="form__line"></div>\n' +
    '  <div class="form-group">\n' +
    '    <button type="button" class="btn-gold_big" ng-click="routeImages.submitChanges()">Сохранить изменения</button>\n' +
    '  </div>\n' +
    '</div>\n' +
    '<button class="close" ng-click="routeImages.close()"></button>\n' +
    '');
}]);

module.exports = "/modals/mountain-route-images/mountain-route-images.html";